import { Box, Dialog, DialogActions, DialogContent } from "@mui/material";
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { useState } from "react";
import Button from "../../../ui/Button";
import Text from "../../../ui/Text";

const libraries = ["places"];
const mapContainerStyle = {
  width: "100%",
  height: "400px",
};

const mapOptions = {
  disableDefaultUI: true,
  zoomControl: true,
};

export const EditPinDialog = ({ selected, onLocationSelect, setSelected }) => {
  const [open, setOpen] = useState(false);
  const [tempLocation, setTempLocation] = useState(selected);
  const [mapInstance, setMapInstance] = useState(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey:
      process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ||
      "AIzaSyC_DfGGmFhYs0EABy_4lE1jPDN0r379XNc",
    libraries,
  });

  const handleOpen = () => {
    setTempLocation(selected);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMapIdle = () => {
    if (mapInstance) {
      const center = mapInstance.getCenter();
      setTempLocation({
        lat: center.lat(),
        lng: center.lng(),
      });
    }
  };

  const handleSave = async () => {
    onLocationSelect(tempLocation);
    setSelected(tempLocation);

    setOpen(false);
  };

  if (!isLoaded) return null;

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Button
          variant="secondary"
          onClick={handleOpen}
          sx={{ width: { xs: "100%", md: "auto" }, height: "35px" }}
        >
          Adjust pin location
        </Button>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        slotProps={{
          paper: { sx: { borderRadius: "12px", m: 2 } },
        }}
      >
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Text variant="subtitle1">Adjust Pin Location</Text>
            <Text variant="paragraph3" color="#666">
              Drag the map to position the pin at the exact location
            </Text>
          </Box>

          <Box sx={{ position: "relative" }}>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              zoom={15}
              center={tempLocation}
              options={mapOptions}
              onLoad={(map) => setMapInstance(map)}
              onIdle={handleMapIdle}
            />
            {/* Fixed center pin - Google Maps style */}
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -100%)",
                pointerEvents: "none",
                zIndex: 1,
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
              }}
            >
              <img
                src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi3.png"
                alt="Location pin"
                style={{ width: "26px", height: "37px" }}
              />
            </Box>
          </Box>

          {/* <Box sx={{ mt: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: "4px" }}>
            <Text variant="paragraph3">
              <strong>Coordinates:</strong> {tempLocation.lat.toFixed(6)},{" "}
              {tempLocation.lng.toFixed(6)}
            </Text>
          </Box> */}
        </DialogContent>

        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save Location
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
